<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="[
          { title: 'おたより一覧', href: '/letter/list', color: 'primary' },
          { title: 'おたより編集' },
        ]"
      ></v-breadcrumbs>
    </div>
    <h3>おたより編集</h3>

    <v-card variant="outlined" class="mt-6 pa-2">
      <v-container>
        <v-row align="center">
          <v-col cols="4">
            <v-text-field
              v-model="letterInput.date"
              label="発行日*"
              type="date"
              density="compact"
              hide-details
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="作成者*"
              v-model="letterInput.createdBy"
              density="compact"
              hide-details
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="letterInput.className"
              label="クラス名"
              density="compact"
              hide-details
              variant="outlined"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row align="center" v-if="category == 'healthLetter'">
          <v-col cols="4">
            <v-text-field
              v-model="letterInput.name"
              label="おたより名*"
              density="compact"
              hide-details
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              :items="metaTitleTypeItems"
              v-model="healthLetterBody[0].meta.titleType"
              label="タイトル種類"
              density="compact"
              hide-details
              variant="outlined"
              item-title="text"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              :items="metaTitleItems"
              v-model="healthLetterBody[0].meta.titleFontSize"
              label="フォントサイズ"
              density="compact"
              hide-details
              variant="outlined"
              item-title="text"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
        
        <v-row align="center" v-else>
          <v-col cols="4">
            <v-text-field
              v-model="letterInput.name"
              label="おたより名*"
              density="compact"
              hide-details
              variant="outlined"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              :items="metaTitleTypeItems"
              v-model="nurseryLetterBody[0].meta.titleType"
              label="タイトル種類"
              density="compact"
              hide-details
              variant="outlined"
              item-title="text"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-select
              :items="metaTitleItems"
              v-model="nurseryLetterBody[0].meta.titleFontSize"
              label="フォントサイズ"
              density="compact"
              hide-details
              variant="outlined"
              item-title="text"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div style="font-size: 18px; color: #dc143c; margin-top: 8px;">
      ※ 枠内に収まるようにテキストを入力してください。
    </div>

    <v-container>
      <v-row align="center" justify="center">
        <v-progress-circular 
          v-show="loading"
          color="primary"
          indeterminate
          :size="150"
        >処理中...</v-progress-circular>
      </v-row>
    </v-container>

    <div class="my-6" v-show="!loading">
      <div class="a4" v-if="category == 'healthLetter'">
        <div style="position: relative">
          <img :src="url" style="width: 100%" />
          <div v-for="(item, i) in healthLetterBody" :key="i">
            <div v-if="item.meta && item.meta.titleType == 'none'"></div>
            <div
              :style="item.style"
              v-else-if="item.meta && item.meta.titleType == 'text'"
            >
              <textarea
                v-model="item.title.text"
                :style="item.title.style + item.meta.titleFontSize"
                class="input-bg"
              />
            </div>
            <div :style="item.style" v-else>
              <textarea
                v-model="item.title.text"
                @input="limitHealthTitleLength($event, item.title)"
                @paste="healthlimitLines($event, item.title)"
                :style="item.title.style"
                class="input-bg"
              />
              <textarea
                v-model="item.body.text"
                @input="limitTextLength($event, item.body, item.maxLength)"
                :style="item.body.style"
                class="input-bg"
              />
              <div 
                class="char-count" 
                style="
                  position: absolute; 
                  bottom: 0px; 
                  right: -30px; 
                  z-index: 3; 
                  background-color: white; 
                  padding: 2px 5px;
                  font-size: 8px;
                ">
                {{ item.body.text.length }} / {{ item.maxLength }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="a4-landscape" v-else-if="category == 'nurseryLetter'">
        <div style="position: relative">
          <img :src="url" style="width: 100%" />
          <div v-for="(item, i) in nurseryLetterBody" :key="i">
            <div v-if="item.meta && item.meta.titleType == 'none'"></div>
            <div
              :style="item.style"
              v-else-if="item.meta && item.meta.titleType == 'text'"
            >
              <textarea
                v-model="item.title.text"
                :style="item.title.style + item.meta.titleFontSize"
                class="input-bg"
              />
            </div>
            <div :style="item.style" v-else>
              <textarea
                v-model="item.title.text"
                @input="limitTitleLength($event, item.title)"
                @paste="limitLines($event, item.title)"
                :style="item.title.style"
                class="input-bg"
              />
              <textarea
                v-model="item.body.text"
                @input="limitTextLength($event, item.body, item.maxLength)"
                :style="item.body.style"
                class="input-bg"
              />
              <div 
                class="char-count" 
                style="
                  position: absolute; 
                  bottom: 0px; 
                  right: -40px; 
                  z-index: 3; 
                  background-color: white; 
                  padding: 2px 5px;
                  font-size: 8px;
                ">
                {{ item.body.text.length }} / {{ item.maxLength }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-container class="mt-6">
      <v-row align="center" justify="center">
        <v-col cols="2" v-if="isUpdate">
          <v-btn
            @click="updateLetter"
            :loading="loading"
            color="primary"
            variant="flat"
            block
          >
            保存
          </v-btn>
        </v-col>
        <v-col cols="2" v-if="isUpdate">
          <v-btn
            @click="exportLetter"
            :loading="loading"
            color="primary"
            variant="outlined"
            block
          >
            <v-icon start>mdi-tray-arrow-down</v-icon>
            ダウンロード
          </v-btn>
        </v-col>
        <v-col cols="2" v-else>
          <v-btn
            @click="createLetter"
            :loading="loading"
            color="primary"
            variant="flat"
            block
          >
            作成
          </v-btn>
        </v-col>
        <v-col cols="2">
          <v-menu location="bottom">
            <template v-slot:activator="{ props }">
              <v-btn
                color="primary"
                class="mx-4"
                :loading="loading"
                variant="outlined"
                block
                v-bind="props"
              >
                定型文で上書き
              </v-btn>
            </template>
              <v-list>
                <v-list-item
                  v-for="i in 12"
                  @click="setTemplateValues(i)"
                  :key="i"
                >
                  <v-list-item-title>
                    {{ `${i}月` }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import ApiLetter from "@/api/ApiLetter";
import { templateText } from "@/constants/letter";
import LocalDataService from "@/service/LocalDataService";
import { LetterResponse } from "chaild-api/lib";
import { defineComponent } from "vue";

type LetterTextObject = {
  text: string;
  style: string;
};

type LetterObject = {
  style: string;
  meta?: {
    titleType: string;
    titleFontSize: string;
  };
  title: LetterTextObject;
  body: LetterTextObject;
  maxLength: number;
};

const LetterTitleStyle =
  "width: 100%; height: 16px; font-size: 10px; text-align: center; font-family: Arial;";
const LetterMainTitleStyle =
  "width: 100%; height: 140px; font-size: 10px; text-align: center; font-family: Arial;";
const LetterBodyStyle = "width: 100%; height: 90%; font-size: 10px; white-space: pre-wrap; font-family: Arial;";
const HealthLetterBody1Style = "width: 520px; height: 48px; font-size: 10px; white-space: pre-wrap; font-family: Arial;";
const HealthLetterBody3Style = "width: 100%; height: 400px; font-size: 10px; white-space: pre-wrap; font-family: Arial;";

const displayNone = "display: none;";
const LetterMetaTitleStyle =
  "position: absolute; top: 50px; width: 100%; height: 50%; text-align: center; vertical-align: middle;";

export default defineComponent({
  name: "LetterEdit",

  async mounted() {
    if (this.isUpdate) {
      await this.getLetter();
    }
  },

  data() {
    return {
      loading: false,
      letterInput: {
        date: "",
        createdBy: "",
        name: "",
        className: "",
      },
      letterResponse: null as null | LetterResponse,
      metaTitleTypeItems: [
        { text: "なし", value: "none" },
        { text: "文字", value: "text" },
      ],
      metaTitleItems: [
        { text: "1rem", value: "font-size: 1rem;" },
        { text: "2rem", value: "font-size: 2rem;" },
        { text: "3rem", value: "font-size: 3rem;" },
        { text: "4rem", value: "font-size: 4rem;" },
        { text: "5rem", value: "font-size: 5rem;" },
      ],
      healthLetterBody: [
        {
          style:
            "position: absolute; top: 0px; left: 0px; height: 160px; width: 100%; background: white; align-items: center;",
          meta: {
            titleType: "none",
            titleFontSize: "font-size: 1rem;",
          },
          title: {
            text: "",
            style: LetterMetaTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle + displayNone,
          },
        },
        {
          style:
            "position: absolute; top: 140px; left: 45px; height: 48px; width: 520px; transform: translateY(-30px);",
          title: {
            text: "",
            style: "height:0px;",
          },
          body: {
            text: "",
            style: HealthLetterBody1Style,
          },
          maxLength: 130,
        },
        {
          style:
            "position: absolute; top: 215px; left: 57px; height: 192px; width: 209px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 200,
        },
        {
          style:
            "position: absolute; top: 429px; left: 57px; height: 322px; width: 209px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 320,
        },
        {
          style:
            "position: absolute; top: 198px; left: 343px; height: 420px; width: 209px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: HealthLetterBody3Style,
          },
          maxLength: 450,
        },
      ] as LetterObject[],
      nurseryLetterBody: [
        {
          style: "position: absolute; top: 20px; left: 20px; height: 140px; width: 48%; background: white; align-items: center;",
          meta: {
            titleType: "none",
            titleFontSize: "font-size: 1rem;",
          },
          title: {
            text: "",
            style: LetterMainTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle + displayNone,
          },
        },
        {
          style: "position: absolute; top: 170px; left: 55px; height: 90px; width: 325px;",
          title: {
            text: "",
            style: LetterTitleStyle + displayNone,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 160,
        },
        {
          style: "position: absolute; top: 260px; left: 55px; height: 85px; width: 325px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 130,
        },
        {
          style: "position: absolute; top: 379px; left: 55px; height: 185px; width: 325px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 300,
        },
        {
          style: "position: absolute; top: 48px; left: 463px; height: 170px; width: 325px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 300,
        },
        {
          style: "position: absolute; top: 236px; left: 463px; height: 170px; width: 325px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 300,
        },
        {
          style: "position: absolute; top: 424px; left: 463px; height: 120px; width: 325px;",
          title: {
            text: "",
            style: LetterTitleStyle,
          },
          body: {
            text: "",
            style: LetterBodyStyle,
          },
          maxLength: 200,
        },
      ] as unknown as LetterObject[],
      templateText: templateText,
    };
  },

  computed: {
    designSlug(): any {
      return this.$route.query.designSlug;
    },
    url(): any {
      if (this.isUpdate) {
        return this.letterResponse?.design.url || "";
      } else {
        return this.$route.query.url;
      }
    },
    month(): any {
      return this.$route.query.month;
    },
    isFullColor(): any {
      return this.$route.query.isFullColor;
    },
    category(): any {
      if (this.isUpdate) {
        return this.letterResponse?.design.category || "healthLetter";
      } else {
        return this.$route.query.category;
      }
    },
    letterId(): any {
      return this.$route.params.letterId;
    },
    isUpdate(): boolean {
      return !!this.letterId;
    },
  },

  methods: {
    async getLetter() {
      if (this.letterId) {
        this.loading = true;
        const response = await ApiLetter.getLetter({
          letterId: this.letterId,
        }).catch(() => (this.loading = false));
        if (response) {
          this.letterResponse = response;
          this.letterInput = {
            date: response.date,
            createdBy: response.createdBy,
            name: response.name,
            className: response.className,
          };
          if (response.design.category == "healthLetter") {
            this.healthLetterBody = response.body;
          } else {
            this.nurseryLetterBody = response.body;
          }
        }
        this.healthLetterBody[1].style = this.healthLetterBody[1].style.replace('translateY(0px)', 'translateY(-30px)');
        this.loading = false;
      }
    },
    async createLetter() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.designSlug) {
        this.loading = true;

        this.healthLetterBody[1].style = this.healthLetterBody[1].style.replace('translateY(-30px)', 'translateY(0px)');

        const response = await ApiLetter.createLetter({
          nurseryId,
          ...this.letterInput,
          designSlug: this.designSlug,
          body:
            this.category == "healthLetter"
              ? this.healthLetterBody
              : this.nurseryLetterBody,
        }).catch(() => (this.loading = false));
        if (response) {
          alert("作成しました");
          this.$router.push({ path: "/letter/list" });
        } else {
          this.healthLetterBody[1].style = this.healthLetterBody[1].style.replace('translateY(0px)', 'translateY(-30px)');
        }
      }
      this.loading = false;
    },
    limitTextLength(event: Event, item: LetterTextObject, maxLength: number) {
      if (item.text.length > maxLength) {
        item.text = item.text.slice(0, maxLength);
      }
    },
    limitTitleLength(event: Event, item: LetterTextObject) {
      const titleMaxLength = 30;
      if (item.text.length > titleMaxLength) {
        item.text = item.text.slice(0, titleMaxLength);
      }
    },
    limitHealthTitleLength(event: Event, item: LetterTextObject) {
      const titleMaxLength = 20;
      if (item.text.length > titleMaxLength) {
        item.text = item.text.slice(0, titleMaxLength);
      }
    },
    healthlimitLines(event: Event, item: LetterTextObject) {
      const textarea = event.target as HTMLTextAreaElement;
      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight || "10px");
      const maxLines = Math.floor(textarea.clientHeight / lineHeight);
      if (textarea.value.endsWith("\n\n")) {
          textarea.value = textarea.value + " " + "\n" + " ";
      } else if (textarea.value.endsWith("\n")) {
        textarea.value = textarea.value + " ";
      }
      const lines = textarea.value.split("\n");
      let adjustedLines: string[] = [];
      lines.forEach(line => {
        let adjustedLine = "";
        for (let i = 0; i < line.length; i++) {
          if (adjustedLine.length >= 20) {
            adjustedLines.push(adjustedLine);
            adjustedLine = "";
          }
          adjustedLine += line[i];
        }
        if (adjustedLine.length > 0) {
          adjustedLines.push(adjustedLine);
        }
      });
      if (adjustedLines.length > maxLines) {
        adjustedLines = adjustedLines.slice(0, maxLines);
      }
      textarea.value = adjustedLines.join("\n");
      if (textarea.value.endsWith(" ")) {
        textarea.value = textarea.value.slice(0, -1);
      }
      item.text = textarea.value;
    },
    limitLines(event: Event, item: LetterTextObject) {
      const textarea = event.target as HTMLTextAreaElement;
      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight || "10px");
      const maxLines = Math.floor(textarea.clientHeight / lineHeight);
      if (textarea.value.endsWith("\n\n")) {
          textarea.value = textarea.value + " " + "\n" + " ";
      } else if (textarea.value.endsWith("\n")) {
        textarea.value = textarea.value + " ";
      }
      const lines = textarea.value.split("\n");
      let adjustedLines: string[] = [];
      lines.forEach(line => {
        let adjustedLine = "";
        for (let i = 0; i < line.length; i++) {
          if (adjustedLine.length >= 32) {
            adjustedLines.push(adjustedLine);
            adjustedLine = "";
          }
          adjustedLine += line[i];
        }
        if (adjustedLine.length > 0) {
          adjustedLines.push(adjustedLine);
        }
      });
      if (adjustedLines.length > maxLines) {
        adjustedLines = adjustedLines.slice(0, maxLines);
      }
      textarea.value = adjustedLines.join("\n");
      if (textarea.value.endsWith(" ")) {
        textarea.value = textarea.value.slice(0, -1);
      }
      item.text = textarea.value;
    },
    async updateLetter() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId && this.letterResponse) {
        this.loading = true;

        this.healthLetterBody[1].style = this.healthLetterBody[1].style.replace('translateY(-30px)', 'translateY(0px)');

        const response = await ApiLetter.updateLetter({
          letterId: this.letterId,
          ...this.letterInput,
          designSlug: this.letterResponse.design.designSlug,
          body:
            this.category == "healthLetter"
              ? this.healthLetterBody
              : this.nurseryLetterBody,
        }).catch(() => (this.loading = false));
        if (response) {
          this.healthLetterBody[1].style = this.healthLetterBody[1].style.replace('translateY(0px)', 'translateY(-30px)');
          alert("更新しました");
        }
      }
      this.loading = false;
    },
    async exportLetter() {
      if (this.letterId) {
        this.loading = true;
        const response = await ApiLetter.exportLetter({
          letterId: this.letterId,
        }).catch(() => (this.loading = false));
        if (response) {
          window.open(response.preSignedDownloadUrl, "_blank");
        }
        this.loading = false;
      }
    },
    setTemplateValues(month: number) {
      this.loading = true;
      if (this.category == "healthLetter") {
        for (let i = 1; i < this.healthLetterBody.length; i++) {
          this.healthLetterBody.splice(i, 1, {
            style: this.healthLetterBody[i].style,
            title: {
              text: this.templateText.healthLetter[month][i - 1].title,
              style: this.healthLetterBody[i].title.style,
            },
            body: {
              text: this.templateText.healthLetter[month][i - 1].body,
              style: this.healthLetterBody[i].body.style,
            },
            maxLength: this.healthLetterBody[i].maxLength,
          });
        }
      } else {
        for (let i = 1; i < this.nurseryLetterBody.length; i++) {
          this.nurseryLetterBody.splice(i, 1, {
            style: this.nurseryLetterBody[i].style,
            title: {
              text: this.templateText.nurseryLetter[month][i - 1].title,
              style: this.nurseryLetterBody[i].title.style,
            },
            body: {
              text: this.templateText.nurseryLetter[month][i - 1].body,
              style: this.nurseryLetterBody[i].body.style,
            },
            maxLength: this.nurseryLetterBody[i].maxLength,
          });
        }
      }
      this.loading = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.a4 {
  height: 842px;
  width: 595px;
}

.a4-landscape {
  height: 595px;
  width: 842px;
}

.input-bg {
  background-color: #f0f0f0;
  border: none;
  resize: none;
  white-space: pre-wrap;
  overflow: hidden;
}
.input-height-140 {
  padding: 16px;
}
.v-progress-circular {
  margin: 1rem;
}
</style>